import SvgColor from '../../../components/svg-color';

export const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1, marginLeft: name == 'ic_reports' ? 2 : 0 }}
  />
);

const navConfig = [
  {
    title: 'Get Started',
    path: '/dashboard/setup',
    icon: icon('ic_setting'),
    isSubOnly: false,
    isExternalLink: false,
    lockable: false,
    children: [],
  },
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: icon('ic_dashboard'),
    isSubOnly: false,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  {
    title: 'Connect Webflow',
    path: '/dashboard/connect-webflow',
    icon: icon('ic_edit'),
    isSubOnly: false,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  // {
  //   title: 'Form Builder',
  //   path: '/dashboard/forms',
  //   icon: icon('ic_edit'),
  //   isSubOnly: true,
  //   isExternalLink: false,
  //   children: [],
  // },
  {
    title: 'Services',
    path: '/dashboard/services',
    icon: icon('ic_list'),
    isSubOnly: true,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  {
    title: 'Bookings',
    path: '/dashboard/bookings',
    icon: icon('ic_calendar'),
    isSubOnly: true,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  {
    title: 'Customers',
    path: '/dashboard/customers',
    icon: icon('ic_user_group'),
    isSubOnly: true,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  {
    title: 'Reports',
    path: '/dashboard/reports',
    icon: icon('ic_reports'),
    isSubOnly: true,
    isExternalLink: false,
    lockable: true,
    children: [],
  },
  {
    title: 'Settings',
    icon: icon('ic_setting'),
    isSubOnly: true,
    isExternalLink: false,
    lockable: true,
    children: [
      {
        title: 'Global Settings',
        path: '/dashboard/settings',
        icon: icon('ic_dot'),
        lockable: true,
      },
      {
        title: 'Email Customizer',
        path: '/dashboard/emails',
        icon: icon('ic_dot'),
        lockable: true,
      },
      {
        title: 'Holiday',
        path: '/dashboard/holiday',
        icon: icon('ic_dot'),
        lockable: true,
      },
      {
        title: 'Payment Settings',
        path: '/dashboard/payment-settings',
        icon: icon('ic_dot'),
        lockable: true,
      },
      {
        title: 'Integrations',
        path: '/dashboard/integrations',
        icon: icon('ic_dot'),
        lockable: true,
      },
      {
        title: 'Google Calendar',
        path: '/dashboard/calendar-integrations',
        icon: icon('ic_dot'),
        lockable: true,
        feature: 'calendar',
      },
    ],
  },
  {
    title: 'Account',
    icon: icon('ic_user'),
    isSubOnly: false,
    isExternalLink: false,
    lockable: false,
    stripePortal: {
      title: 'Billing',
      path: null,
      icon: icon('ic_pop'),
    },
    children: [
      { title: 'Profile', path: '/dashboard/profile', icon: icon('ic_dot'), lockable: false },
    ],
  },
  {
    title: 'Support',
    icon: icon('ic_pop'),
    isSubOnly: false,
    isExternalLink: true,
    lockable: false,
    path: 'https://www.flowbookings.io/contact',
    children: [],
  },
];

export default navConfig;
